var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"width":"350","fixed":"","temporary":"","right":""},model:{value:(_vm.storeResource.status),callback:function ($$v) {_vm.$set(_vm.storeResource, "status", $$v)},expression:"storeResource.status"}},[_c(_vm.storeResource.componentName,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }